
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicare-chatbot",
      function () {
        return require("private-next-pages/medicare-chatbot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicare-chatbot"])
      });
    }
  